export const STATUS = [
  { key: "backlog", label: "Backlog" },
  { key: "todo", label: "To Do" },
  { key: "in_progress", label: "In Progress" },
  { key: "blocked", label: "Blocked" },
  { key: "review", label: "Review / QA" },
  { key: "awaiting_approval", label: "Awaiting Approval" },
  { key: "done", label: "Done" },
  { key: "cancelled", label: "Cancelled" },
];
export const STATUS_LABEL = Object.fromEntries(STATUS.map((s) => [s.key, s.label]));

export const DEPTS = {
  development: { label: "Development", blurb: "Features, bugs, infrastructure, testing, QA and releases" },
  marketing: { label: "Marketing", blurb: "Campaigns, content, partnerships, creative assets and publishing" },
  owner: { label: "Owner", blurb: "Product decisions, assigned actions, approvals and release authorizations" },
  support: { label: "Support", blurb: "Customer tickets, incidents, inquiries, escalations and resolutions" },
};

export const PRIORITY_TONE = {
  P0: "bg-[#C2412D] text-white",
  P1: "bg-[#E2A33B] text-[#071E3E]",
  P2: "bg-[#2F6FB3]/15 text-[#2F6FB3]",
  P3: "bg-slate-200 text-slate-600",
};

export const isOverdue = (t) => t.deadline && !["done", "cancelled"].includes(t.status) && new Date(t.deadline) < new Date();

export const field = "w-full rounded-sm border border-[var(--cc-line)] bg-white px-3 py-2 text-sm outline-none focus:border-[var(--cc-navy)]";
export const primaryBtn = "rounded-sm bg-[var(--cc-navy)] px-4 py-2 text-xs font-medium text-white transition-colors hover:bg-[var(--cc-signal)] hover:text-[var(--cc-navy)] disabled:opacity-50";
export const ghostBtn = "rounded-sm border border-[var(--cc-line)] px-3 py-1.5 text-xs transition-colors hover:border-[var(--cc-navy)]";

export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};
export const fromLocalInput = (v) => (v ? new Date(v).toISOString() : null);
